import "./fileConflicts.scss";

import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import ModalBody from "../../components/modal/ModalBody";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterLeftGroup from "../../components/modal/ModalFooterLeftGroup";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalView from "../../components/modal/ModalView";
import PubSubTopics from "../../constants/pubSubTopics";
import Dimensions from "../../constants/styles/dimensions";
import dialogs from "../../dialogs";
import { fileConflictsSelectors } from "../../modules/fileConflicts";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import preprocessorQuery from "../../utils/preprocessorQuery";

const isMobile = preprocessorQuery.isMobile();

const renderVersion = (version, isSelected, onSelectVersion) => {
  const onClick = () => onSelectVersion(version.id);
  let classNames = ["fileConflictVersion"];
  if (isSelected) {
    classNames.push("selected");
  }
  return (
    <div key={version.id} className={classNames.join(" ")} onClick={onClick}>
      <div className="fileConflictVersionName">{version.name}</div>
      <div className="fileConflictVersionDate">{version.date}</div>
    </div>
  );
};

const getSelectedVersion = (fileVersions, lastSelectedId) => {
  const selectedVersion = fileVersions.find(v => {
    v.id === lastSelectedId;
  });
  if (selectedVersion) {
    return selectedVersion.id;
  }
  const currentVersion = fileVersions.find(v => v.isCurrent);
  if (currentVersion) {
    return currentVersion.id;
  }
  return fileVersions.size > 0 ? fileVersions.first().id : null;
};

class FileConflictsModal extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedVersion: getSelectedVersion(props.fileVersions, null)
    };
    this.onSelectVersionClick = this.onSelectVersionClick.bind(this);
    this.onConfirmClick = this.onConfirmClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  componentDidMount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.FILE_CONFLICT_MODAL_OPENED
    });
  }

  componentWillReceiveProps(nextProps) {
    const selectedVersion = getSelectedVersion(nextProps.fileVersions, this.state.selectedVersion);
    if (selectedVersion !== this.state.selectedVersion) {
      this.setState({
        selectedVersion
      });
    }
  }

  componentWillUnmount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.FILE_CONFLICT_MODAL_CLOSED
    });
  }

  onSelectVersionClick(selectedVersion) {
    this.setState({
      selectedVersion
    });
  }

  onConfirmClick() {
    const message = "Are you sure you want to keep this and delete other versions?";
    const title = "Resolve Conflicts";
    const callback = result => {
      if (result) {
        const data = {
          msg: nativeCommsBroadcastMessageTypes.RESOLVE_CONFLICT_CHOOSING_VERSIONS,
          versions: this.state.selectedVersion
        };
        PubSub.publish(PubSubTopics.sendNativeMessage, data);
      }
    };
    dialogs.okCancelPrompt(message, callback, title);
  }

  onCancelClick() {
    const data = {
      msg: nativeCommsBroadcastMessageTypes.CANCEL_CONFLICT_RESOLUTION
    };
    PubSub.publish(PubSubTopics.sendNativeMessage, data);
  }

  renderVersions() {
    const childComponents = this.props.fileVersions
      .map(v => renderVersion(v, v.id === this.state.selectedVersion, this.onSelectVersionClick))
      .toArray();

    return (
      <ModalGroup>
        <div className="fileConflictVersionGroup">{childComponents}</div>
      </ModalGroup>
    );
  }

  render() {
    const headingText = isMobile ? "Choose version" : "Choose version to keep";
    const modalHeading = <ModalHeading title={headingText} showCancel={false} showDone={false} />;
    const modalFooter = (
      <ModalFooter>
        <ModalFooterLeftGroup>
          <FormButton label="Close File" className="fileConflictsActionButton" onClick={this.onCancelClick} />
        </ModalFooterLeftGroup>
        <ModalFooterRightGroup>
          <FormButton
            primary={true}
            label="Keep Version"
            className="fileConflictsActionButton"
            onClick={this.onConfirmClick}
            disabled={!this.state.selectedVersion}
          />
        </ModalFooterRightGroup>
      </ModalFooter>
    );
    let fixedHeight = null;

    //#!if mobile === true
// fixedHeight = Dimensions.MODAL_MAX_HEIGHT;
    //#!endif

    return (
      <ModalView header={modalHeading} footer={modalFooter} fixedHeight={fixedHeight}>
        <ModalBody>{this.renderVersions()}</ModalBody>
      </ModalView>
    );
  }
}

FileConflictsModal.propTypes = {
  fileVersions: ImmutablePropTypes.list.isRequired
};

const mapStateToProps = state => {
  return {
    fileVersions: fileConflictsSelectors.getConflictVersions(state.present)
  };
};

export default connect(mapStateToProps, null)(FileConflictsModal);
